import { Navigate, Route, Routes } from "react-router-dom";

import MaintenanceControl from "./maintenanceControl";
import Monitoring from "./monitoring";
import DealershipAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";
import ServiceBayControl from "./serviceBayControl";

const DealershipRoutes = (props: any) => (
  <Routes>
    <Route
      path="/"
      element={<Navigate to="/dealership/maintenance-control" />}
    />
    <Route path="/monitoring" element={<Monitoring {...props} />} />
    <Route path="/maintenance-control" element={<MaintenanceControl {...props} />} />
    <Route path="/maintenance-monitoring" index element={<MaintenanceMonitoring {...props} />} />
    <Route
      path="/appointments/*"
      index
      element={<DealershipAppointmentsRoutes {...props} />}
    />
    <Route path="/service-bay-control" index element={<ServiceBayControl {...props} />} />
  </Routes>
);

export default DealershipRoutes;
